import { GraphQLClient } from 'graphql-request';
import { getCookies } from 'src/utils/cookies';

const graphQLClient = new GraphQLClient(
  `${process.env.NEXT_PUBLIC_API_URL}/graphql`,
  {
    credentials: 'include',
    headers() {
      const { csrfToken } = getCookies();

      return {
        'x-csrf-token': csrfToken,
      };
    },
  },
);

/**
 *
 * @deprecated use the hooks exported directly from generated
 */
export const sdk =
  <Data, Variables>(
    query: string,
    variables?: Variables,
    options?: Parameters<GraphQLClient['setHeaders']>[0],
  ) =>
  async () =>
    graphQLClient.request<Data, Variables>(query, variables, options);
